/**
 * 学习乐园 · 连连看题材包：单位换算（lianliankan/pack-danwei.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：一个量连它的等值换算（「1 时」连「60 分」）。时间、长度、
 * 质量、容积四类各收几对，只收小学口径的常用单位（毫米到千米、克到吨、
 * 毫升到升），进率如实标注——时间进率 60、质量容积进率 1000、
 * 长度里米到千米是 1000 其余相邻是 10，这些「不一样」正是考点本身。
 * note 给换算口诀或一个身上的参照物（两袋盐 1 千克、大瓶可乐 1 升）。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.danwei = {
    id: 'danwei',
    name: '单位换算',
    hint: '时、米、千克、升，换过来换过去',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '1 时', r: '60 分', note: '一时等于六十分' },
      { l: '2 时', r: '120 分', note: '两时就是一百二十分' },
      { l: '半时', r: '30 分', note: '半小时就是 30 分' },
      { l: '1 分', r: '60 秒', note: '一分等于六十秒' },
      { l: '2 分', r: '120 秒', note: '两分等于一百二十秒' },
      { l: '3 分', r: '180 秒', note: '三分等于一百八十秒' },
      { l: '1 千米', r: '1000 米', note: '千米又叫公里' },
      { l: '3 千米', r: '3000 米', note: '操场一圈 400 米，七圈半是 3 千米' },
      { l: '1 米', r: '100 厘米', note: '一米等于一百厘米' },
      { l: '2 米', r: '20 分米', note: '一米是十分米' },
      { l: '5 米', r: '500 厘米', note: '米到厘米隔两级，进率是 100' },
      { l: '1 分米', r: '10 厘米', note: '一分米等于十厘米' },
      { l: '1 厘米', r: '10 毫米', note: '一厘米等于十毫米' },
      { l: '1 千克', r: '1000 克', note: '两袋盐大约就是 1 千克' },
      { l: '2 千克', r: '2000 克', note: '千克到克进率 1000' },
      { l: '1 吨', r: '1000 千克', note: '吨是大件用的：一头牛约半吨' },
      { l: '1 升', r: '1000 毫升', note: '一大瓶可乐正好 1 升' },
      { l: '2 升', r: '2000 毫升', note: '升到毫升进率也是 1000' },
      { l: '90 分', r: '1 时 30 分', note: '一时半就是 90 分' },
      { l: '240 秒', r: '4 分', note: '240 里有 4 个 60' },
      { l: '5 千米', r: '5000 米', note: '千米到米进率 1000' },
      { l: '3 米', r: '300 厘米', note: '米到厘米隔两级，进率 100' },
      { l: '4 分米', r: '40 厘米', note: '一分米等于十厘米' },
      { l: '3 千克', r: '3000 克', note: '三千克就是 3000 克' },
      { l: '5 吨', r: '5000 千克', note: '五吨等于五千千克' },
      { l: '3 升', r: '3000 毫升', note: '升到毫升进率 1000' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
